import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { TableloaderComponent } from './tableloader.component';



@NgModule({
  declarations: [TableloaderComponent],
  imports: [
    CommonModule,
    NgxUiLoaderModule,
  ],
  exports:[TableloaderComponent],
  providers: [TableloaderComponent],
})
export class TableloaderModule { }
